/*
 ** These values are predefined by Snipcart and shouldn't be changed unless changed by Snipcart
 */
export const SNIP_CART_JWT_TOKEN = "snipcart_jwt";
export const SNIP_CART = "snipcart-cart";
export const SHOPWARE_ACCESS_TOKEN = "sw-access-token";
